import React from 'react';
import * as AgGrid from '@ag-grid-community/core';
import { AgGridReact } from '@ag-grid-community/react';
import {
  ColDef,
  CellClassParams,
  ValueSetterParams,
  CellRendererSelectorResult,
  CellEditorSelectorResult,
  ExcelStyle,
} from '@ag-grid-community/core';
import { AxiosPromise, CancelTokenSource, default as AxiosStatic } from 'axios';

import Axios from 'src/services/axios';
import {
  mapValues,
  isArray,
  isEqual,
  size,
  merge,
  isEmpty,
  isUndefined,
  sortBy,
  reduce,
  concat,
  get,
  groupBy,
  last,
  split,
  filter,
  omitBy,
  noop,
} from 'lodash';
import { find, isNil, map, partial, toString } from 'lodash/fp';
import { ClientDataApi } from 'configuration-schemas/confdefnView';
import {
  ColorHeaderCellRenderer,
  ColorHeaderRenderer,
  SwatchSelector,
} from 'src/pages/AssortmentBuild/StyleEdit/StyleEditSection/Renderers/ColorHeaderRenderer';
import { default as NonFrameWorkToS5Renderer } from 'src/pages/AssortmentBuild/StyleEdit/StyleEditSection/Renderers/NonFrameWorkToS5Renderer';
import { RangePickerRenderer } from 'src/pages/AssortmentBuild/StyleEdit/StyleEditSection/Renderers/RangePickerRenderer';
import { default as RangePickerEditor } from 'src/pages/AssortmentBuild/StyleEdit/StyleEditSection/Editors/RangePickerEditor.container';
import { ImageCellRenderer } from 'src/pages/AssortmentBuild/StyleEdit/StyleEditSection/Renderers/ImageCellRenderer';
import { IconCellRenderer } from './Renderers/IconCellRenderer';
import TooltipRenderer from './Renderers/TooltipRenderer';
import { PopoverSelect } from './Editors/PopoverSelect';
import { classes, style } from 'typestyle';
import { toast } from 'react-toastify';
import handleViewport from 'react-in-viewport';

import * as StyleEditSectionStyles from './StyleEditSection.styles';
import ValidValuesEditor from 'src/pages/AssortmentBuild/StyleEdit/StyleEditSection/Editors/ValidValuesEditor';
import { ValidSizesRenderer } from 'src/pages/AssortmentBuild/StyleEdit/StyleEditSection/Renderers/ValidSizesRenderer';
import CheckboxCellRenderer from './Renderers/Checkbox';
import { processApiParams, getUrl, getClientHandler, getViewProm } from '../StyleEdit.utils';
import StyleEditAddColorButton from 'src/components/AddColorButton/AddColorButton';
import TemplateModalWithButton from 'src/components/TemplateModalWithButton/TemplateModalWithButton';
import { Icon, TextField } from '@material-ui/core';
import { getAllColors } from '../../AssortmentAdd/Assortment.client';
import {
  updateLifecycleParams,
  removeStyleColor,
  getExistingColorsNotInAsst,
  updateRangingParams,
} from './StyleEditSection.client';
import { updateStyleItem } from '../StyleEdit.client';
import { BasicPivotItem } from 'src/worker/pivotWorker.types';
import Overlay from 'src/common-ui/components/Overlay/Overlay';
import Renderer, { RendererOptions } from 'src/utils/Domain/Renderer';
import {
  ADJUSTED_APS,
  CC_COLOR,
  SPECIAL_STORE_GROUP,
  RANGE_CODE,
  VALID_SIZES,
  LOCKED_AFTER_COLOR_SUBMIT,
  COLOR_SUBMITTED_ATTR,
  FUNDED,
  POPOVER_BLOCK_CODES,
  BLOCK_ENTER_EDITORS,
  STORE_COUNT,
} from 'src/utils/Domain/Constants';
import ValidValuesRenderer from './Renderers/ValidValuesRenderer';
import ModalLinkRenderer from './Renderers/ModalLinkRenderer';
import ConfirmationModal from 'src/components/ConfirmationModal/ConfirmationModal';
import { AssortmentClient } from '../../Assortment.client';
import { getRangeLists } from 'src/dao/scopeClient';
import IntegerEditor from './Editors/IntegerEditor/IntegerEditor';
import * as globalMath from 'mathjs';
import {
  executeCalculation,
  importDateFunctions,
  getVarsFromCalcString,
  GetDataCalculation,
} from 'src/utils/LibraryUtils/MathUtils';
import { arrayStringToArray } from 'src/utils/Primitive/String';
import {
  TextValidationEditor,
  PENDING_VALIDATION_VALUE,
  PendingCellInfo,
  viewDefnWhitelistToNarrowedCharacterWhitelist,
} from './Editors/TextValidationEditor';
import {
  DependentData,
  StyleEditSectionState,
  StyleEditSectionProps,
  GridTitleProps,
  NotInLifecycleRendererProps,
  StyleEditConfigColumn,
  ColorHeaderConfigColumn,
  MultiRangeEditors,
  TransposedColDef,
} from './StyleEditSection.types';
import ClearValueCellRenderer from './Renderers/ClearValue';
import {
  ExcelExportParams,
  ProcessCellForExportParams,
  CsvExportParams,
  GridApi,
  RowHeightParams,
  RowClassParams,
  IRowNode,
  ExcelCell,
} from '@ag-grid-community/core';
import { StyleEditSectionHeaderGrid } from './StyleEditSectionHeaderGrid';
import { getRowHeight, refreshCellsOnly, setGridRowHeights, submitGranular } from './StyleEditSection.utils';
import { AsyncValidationErrorMessage } from 'src/components/ConfigurableGrid/EditableGrid/EditableGrid.subcomponents';
import { maybeReturnNestData } from 'src/utils/Http/NestedDatas';
import LocalPivotServiceContext from 'src/components/StylePreview/PivotServiceContext';
import ServiceContainer from 'src/ServiceContainer';
import { createId } from '@paralleldrive/cuid2';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, buffer } from 'rxjs/operators';
import { AppType } from 'configuration-schemas/general';
import { z } from 'zod';
import { Autocomplete } from '@material-ui/lab';
import { important } from 'csx';
import {
  autocompleteStyles,
  generalPopper,
  generalPopupIndicator,
} from 'src/common-ui/components/Inputs/InputSuggest/InputSuggest.styles';
import { KeyboardArrowDown } from '@material-ui/icons';
import { GranularEditPayloadItem } from 'src/dao/pivotClient';
import { GroupRowCellRenderer } from './Renderers/GroupRowCellRenderer';
import { SelectedOption } from 'src/pages/AssortmentCart/ColorsEdit/ColorsEdit';
import { ValidSizesEditor } from './Editors/ValidSizesEditor';
import { listBoxVirtualizedWithRef } from 'src/common-ui/components/Inputs/InputSuggest/InputSuggest';
import { getCellAsyncState, updateNodeAsyncState } from 'src/components/ConfigurableGrid/utils/ConfigurableGrid.utils';
import { AsyncCellState } from 'src/components/ConfigurableGrid/ConfigurableGrid.types';

const NOT_FOUND = '__DATA__NOT__FOUND__';
const DEFAULT_COLDEF = {
  width: 200,
};
interface getDataFromKeyParams {
  api?: GridApi;
  colDef?: ColDef;
}
function getDataFromKey(params: getDataFromKeyParams, group: string | null | undefined, colKey: string) {
  let returnObj: GetDataCalculation = {
    rowNodeFound: false,
    data: undefined,
  };
  const key = group ? `${group}$$${colKey}` : colKey;
  if (!isNil(params.api) && !isNil(params.api.getRowNode(key))) {
    const rowNode = params.api.getRowNode(key);
    if (!isNil(rowNode) && params.colDef?.field) {
      returnObj = {
        rowNodeFound: true,
        data: params.api.getValue(params.colDef.field, rowNode),
      };
    }
  }
  return returnObj;
}

const StyleEditGridTitle = (props: GridTitleProps) => {
  const { title } = props;

  return (
    <div className={StyleEditSectionStyles.sectionGridTitle}>
      <div className={'leftTitleContainer'}>
        <span>{title}</span>
      </div>
    </div>
  );
};

const NotInLifecycleRenderer = (props: NotInLifecycleRendererProps) => {
  return <div className={StyleEditSectionStyles.notInLifecycle}>{props.text}</div>;
};

const renderOption = (props: SelectedOption) => (
  <li
    {...props}
    data-existing={props.isExisting} // property to allow for color changes in css
  >
    {props.label || props.value}
  </li>
);

type ObserverObject = {
  dataApi: ClientDataApi;
};

type Item = {
  styleColorId: string;
  update: any;
};

export class StyleEditSection extends React.Component<StyleEditSectionProps, StyleEditSectionState> {
  static contextType = LocalPivotServiceContext;
  context!: React.ContextType<typeof LocalPivotServiceContext>;
  private _isMounted: boolean; // FIXME: is this necessary?
  savedCalcData: Record<string, any> = {};
  nonFrameworkComponents: any;
  frameworkComponents: any;
  groupRowRendererParams = {};
  allGridComponents: any;
  dataQueue!: AxiosPromise<any>[];
  // gridApi and headerApi need to initialize as undef
  // because in some rare cases the grid will call functions with api = null
  // and we need to guard against those cases crashing the view
  gridApi: AgGrid.GridApi | undefined = undefined;
  headerGridApi: AgGrid.GridApi | undefined = undefined;
  math = globalMath.create(globalMath.all) as globalMath.MathJsStatic;
  componentId = createId();

  // Rx-js updating
  updateItemSubject: Subject<Item> | undefined;
  debounceUpdateItem$: Observable<Item> | undefined;
  updateItem$: Observable<Item[]> | undefined;
  updateItem$Subscriber: Subscription | undefined;

  // single observed property can contain multiple observers
  observers: { [s: string]: { [s: string]: { [s: string]: ObserverObject } } } = {};
  stickySectionElement: any;

  // cancel token
  private redecorateCancel?: CancelTokenSource;

  constructor(props: StyleEditSectionProps) {
    super(props);
    this._isMounted = false;
    this.nonFrameworkComponents = {
      nonFrameWorkToS5Renderer: NonFrameWorkToS5Renderer,
    };
    this.frameworkComponents = {
      // TODO: only required for use in StyleEditMultiSection,
      // once that component is no longer relied on this can be removed in favor of the set `agColumnHeader` below
      colorHeaderCellRenderer: ColorHeaderCellRenderer,
      iconCellRenderer: IconCellRenderer,
      imageCellRenderer: ImageCellRenderer,
      validValuesEditor: ValidValuesEditor,
      validValuesRenderer: ValidValuesRenderer,
      rangePickerRenderer: RangePickerRenderer,
      rangePickerEditor: RangePickerEditor,
      checkboxCellRenderer: CheckboxCellRenderer,
      popoverSelectEditor: PopoverSelect,
      validSizesRenderer: ValidSizesRenderer,
      notInLifecycle: NotInLifecycleRenderer,
      integerEditor: IntegerEditor,
      textValidationEditor: TextValidationEditor,
      clearValueRenderer: ClearValueCellRenderer,
      tooltipRenderer: TooltipRenderer,
      modalLinkRenderer: ModalLinkRenderer,
      validSizesEditor: ValidSizesEditor,
    };
    this.groupRowRendererParams = {
      suppressCount: true,
    };
    this.allGridComponents = {
      ...this.nonFrameworkComponents,
      ...this.frameworkComponents,
      agColumnHeader: ColorHeaderRenderer,
    };
    this.observers = {};
    this.state = {
      transposedDefs: null,
      colDefs: null,
      rowData: null,
      transposedData: null,
      pinnedData: undefined,
      disabledIds: [],
      addColorModalOpen: false,
      dependentData: null,
      isLoading: null,
      isAddingColor: false,
      submittedStyleColors: [],
      confirmationModalProps: {
        isOpen: false,
        descriptionText: '',
      },
      mergedRangeList: undefined,
    };
  }

  getComponentId = () => {
    return this.props.componentIdOverride ? this.props.componentIdOverride : this.componentId;
  };

  componentDidMount() {
    this.getSectionDataAndConfig();

    // Using an rx-js stream, collect updates that occur during a 20ms window and send them all at once
    // Fixes things like lifecycle updates needing to do updates at once
    this.updateItemSubject = new Subject();
    this.debounceUpdateItem$ = this.updateItemSubject.pipe(debounceTime(20));
    this.updateItem$ = this.updateItemSubject.pipe(buffer(this.debounceUpdateItem$));
    this.updateItem$Subscriber = this.updateItem$.subscribe((result) => {
      let styleColorId = '';
      const update = result.reduce((prevVal, newVal) => {
        styleColorId = newVal.styleColorId;
        return merge(prevVal, newVal.update);
      }, {}) as { [s: string]: any };

      updateLifecycleParams(styleColorId, update)
        .then(() => {
          this.context.clearPivotCache();
          this.props.refreshSections(this.getComponentId());
        })
        .catch((e) => {
          toast.error('An error occured updating your lifecycle parameters');
          ServiceContainer.loggingService.error(
            'An error occured updating the lifecycle parameters in Style edit lifecylce paramters',
            e.stack,
          );
        });
    });
  }

  componentDidUpdate(prevProps: StyleEditSectionProps) {
    if (!isEqual(this.props.sortedStyleColorIds, prevProps.sortedStyleColorIds)) {
      if (!isNil(this.gridApi)) {
        this.reorderAndFilterColumns(this.gridApi);
      }
      if (!isNil(this.headerGridApi)) {
        this.reorderAndFilterColumns(this.headerGridApi);
      }

      // only want to refresh on update in multisection since data is not updated
      if (!isNil(this.props.multiSectionData)) {
        if (!isNil(this.gridApi)) {
          this.gridApi.refreshCells();
        }
        if (!isNil(this.headerGridApi)) {
          this.headerGridApi.refreshCells();
        }
      }
    }
    if (!isEqual(this.props.headerData, prevProps.headerData)) {
      if (this.gridApi && this.headerGridApi) {
        this.gridApi.redrawRows();
        this.headerGridApi.redrawRows();
        setGridRowHeights(this.state.colDefs, this.gridApi);
      }
      this.gridApi?.refreshCells();
      this.gridApi?.refreshHeader();
    }

    if (!isNil(prevProps.styleId) && !isNil(this.props.styleId) && prevProps.styleId !== this.props.styleId) {
      this.getSectionDataAndConfig();
    }
    const isCurrent = this.props.lastEditedSection === this.getComponentId();
    if (
      !isNil(prevProps.multiSectionData) &&
      !isNil(this.props.multiSectionData) &&
      !isEqual(prevProps.multiSectionData.data, this.props.multiSectionData.data)
    ) {
      /* //TODO add support for multisection redecoration
      const isMultiSectionListData = this.props.multiSectionData?.config.dataApi?.isListData;
      if (isCurrent && this.props.multiSectionData?.config.isListData && isMultiSectionListData === true) {
        this.redecorateRowData();
      } else if (!isCurrent) {
        this.handleMultiSection();
      }*/
      this.handleMultiSection();
    } else if (this.props.currentRefreshCount > prevProps.currentRefreshCount) {
      if (!isCurrent) {
        this.getSectionDataAndConfig();
      }
    }

    if (prevProps.expanded && !this.props.expanded) {
      // because sections never unmount anymore, this code repeats
      // what would happen on unmount, but instead when the section is un-expanded
      if (this.props.getHeaderElement) {
        this.props.getHeaderElement(undefined);
      }
      // we need to wipe the apis as the underlying grids are now destroyed on collapse (we don't unmount no more)
      this.gridApi = undefined;
    }
  }

  componentWillUnmount() {
    if (this.redecorateCancel) {
      this.redecorateCancel.cancel('component unmounted');
    }
    if (this.props.getHeaderElement) {
      this.props.getHeaderElement(undefined);
    }
    this._isMounted = false;
    if (this.updateItem$Subscriber) {
      this.updateItem$Subscriber.unsubscribe();
    }
  }

  getExportOptions = () => {
    const { sectionData, multiSectionData } = this.props;
    const title = isNil(multiSectionData) ? (sectionData ? sectionData.text : '') : multiSectionData.text;
    const additionalExcelExports = {
      customHeader: title,
      excelRendererObj: Renderer.getAllExcelRenderers(),
    };
    return additionalExcelExports;
  };

  onCsvExport = () => {
    if (isNil(this.gridApi)) {
      // this shouldn't happen
      throw new Error('csv export called, but no gridapi was found');
    }
    let csvOptions: CsvExportParams = {
      processCellCallback: (params: ProcessCellForExportParams) => {
        const { column, node, value } = params;
        const colDefs: (StyleEditConfigColumn | ColorHeaderConfigColumn)[] = this.state.colDefs;
        const rowIndex = colDefs.findIndex((def) => {
          return def.dataIndex === (last(split(node?.id, '$$')) || null);
        });
        const colInfo = colDefs[rowIndex];
        const cellRenderer = colInfo.renderer;
        const renderer = typeof cellRenderer === 'string' ? cellRenderer : '';
        const renderFn = renderer ? Renderer[renderer as RendererOptions] : undefined;

        // @ts-expect-error
        return column.getColId() !== 'headerText' && renderFn ? renderFn(value) : value;
      },
      processHeaderCallback: (params: AgGrid.ProcessHeaderForExportParams) => {
        if (!this.state.rowData) return;
        const { column } = params;
        const id = column.getDefinition().headerName;
        const val: BasicPivotItem = this.state.rowData.find((data: BasicPivotItem) => {
          return data.id === id;
        });
        return get(val, 'attribute:cccolor:name') || '';
      },
    };

    const exportOptions = this.getExportOptions();
    csvOptions = {
      ...csvOptions,
      prependContent: exportOptions.customHeader + '\n',
    };

    this.gridApi.exportDataAsCsv(csvOptions);
  };

  onExcelExport = () => {
    if (isNil(this.gridApi)) {
      // this shouldn't happen
      throw new Error('xls export called, but no gridapi was found');
    }
    const exportOptions = this.getExportOptions();
    let excelOptions: ExcelExportParams = {
      sheetName: 'S5 Assortment Export',
      processCellCallback: (params: ProcessCellForExportParams) => {
        const { column, node, value } = params;
        const colDefs: (StyleEditConfigColumn | ColorHeaderConfigColumn)[] = this.state.colDefs;
        const rowIndex = colDefs.findIndex((def) => {
          return def.dataIndex === (last(split(node?.id, '$$')) || null);
        });
        const colInfo = colDefs[rowIndex];
        const cellRenderer = colInfo.renderer;
        const renderer = typeof cellRenderer === 'string' ? cellRenderer : '';
        const renderFn = renderer ? Renderer[renderer as RendererOptions] : undefined;

        if (exportOptions && exportOptions.excelRendererObj && renderer !== '') {
          const excelFormat = exportOptions.excelRendererObj[renderer];
          if (excelFormat) {
            return value;
          }
        }
        // @ts-expect-error
        return column.getColId() !== 'headerText' && renderFn ? renderFn(value) : value;
      },
      processHeaderCallback: (params: AgGrid.ProcessHeaderForExportParams) => {
        if (!this.state.rowData) return;
        const { column } = params;
        const id = column.getDefinition().headerName;
        const val: BasicPivotItem = this.state.rowData.find((data: BasicPivotItem) => {
          return data.id === id;
        });
        return get(val, 'attribute:cccolor:name') || '';
      },
    };

    const header: ExcelCell[][] = new Array(1);
    header.push([
      {
        data: {
          type: 'String',
          value: exportOptions.customHeader,
        },
        mergeAcross: 2,
      },
    ]);
    excelOptions = {
      ...excelOptions,
      // @ts-ignore unsure how to fix
      customHeader: header,
      // fileName: (fileName && fileName + ' at ' + dayjs().format('YYYY-MM-DD hh|mmA')),
    };
    this.gridApi.exportDataAsExcel(excelOptions);
  };

  getSectionDataAndConfig() {
    this._isMounted = true;
    const { multiSectionData } = this.props;

    if (isNil(multiSectionData)) {
      this.handleStandardSection();
      // standard section makes and async call, at the end of which, loading is set to false
      // set it to true here to keep the component to toggle the overlay on, and it'll get toggled off
      // when the async inside handleStandardSection() returns
      this.setState({
        isLoading: this.props.sectionData ? this.props.sectionData.dataApi : null,
      });
    } else {
      this.handleMultiSection();
    }
  }

  // set asyncstate on nodes (row-scoped) and refresh just the requested columns
  applyAsyncState = (nodes: IRowNode[], columns: (string | AgGrid.Column)[] | undefined, state: AsyncCellState) => {
    if (!this.gridApi || !nodes.length) return;

    nodes.forEach((n) => {
      const rowKey = n.data?.dataKey as string | undefined;
      if (rowKey) updateNodeAsyncState(n, [rowKey], state);
    });

    const colsToRefresh = columns && columns.length ? columns : (this.gridApi.getColumns?.() ?? []);
    refreshCellsOnly(this.gridApi, nodes, colsToRefresh, { forceRefresh: true, suppressFlash: true });
  };

  // centralize state change around redecorate
  runRedecorate = async (node?: IRowNode<any> | null, column?: string | AgGrid.Column) => {
    if (!node || !column) return;
    this.applyAsyncState([node], [column], AsyncCellState.Redecorating);
    try {
      await this.redecorateRowData();
    } finally {
      this.applyAsyncState([node], [column], AsyncCellState.Idle);
    }
  };

  redecorateRowData = async () => {
    const { actions, colDefs, dependentData, multiRangeEditors, rowData } = this.state;

    try {
      const sectionData = this.props.multiSectionData?.config ?? this.props.sectionData;
      // return if redecorate isnt supported
      if (isNil(rowData) || isNil(sectionData) || !sectionData.dataApi?.isListData) return;

      // just to be safe, cancel an older one too
      this.redecorateCancel?.cancel('superseded');
      this.redecorateCancel = AxiosStatic.CancelToken.source();

      // get rowData untransposed from the grid, to match current edits
      const groupKey = this.props.sectionData?.rowGroupDataIndex;
      const gridRowData = [...rowData];
      this.state.colDefs.forEach((col: { dataIndex: string }) => {
        const attr = col.dataIndex;
        gridRowData.forEach((row) => {
          const colorId = row.id ?? row.product;
          let node: AgGrid.IRowNode | undefined;
          if (groupKey != null) {
            // this condition is for future if multi-grid is configured
            const groupV = row[groupKey];
            node = this.gridApi?.getRowNode(`${groupV}$$${attr}`); // see getRowId for why to concat with $$
          } else {
            node = this.gridApi?.getRowNode(attr);
          }
          const data = node?.data;
          if (data == null) return;
          row[attr] = data[colorId]; //colorId is the "column" that contains the value
        });
      });
      const newRowData = await ServiceContainer.pivotService.redecorate(
        {
          coordinates: gridRowData,
          defnId: sectionData.dataApi.defnId,
          nestData: false,
          aggBy: [sectionData.dataApi.params.aggBy],
        },
        this.redecorateCancel.token,
      );

      this.transposeRowsAndColumns(
        newRowData,
        colDefs,
        actions,
        multiRangeEditors!,
        dependentData,
        sectionData?.rowGroupDataIndex ?? null,
      );
    } catch (err) {
      if (AxiosStatic.isCancel(err)) return;
      toast.error('An error occurred updating lifecycle parameters');
      console.error(err);
    } finally {
      this.redecorateCancel = undefined;
    }
  };

  handleStandardSection() {
    if (this.state.isLoading && this.props.sectionData && isEqual(this.state.isLoading, this.props.sectionData.dataApi))
      return;
    const { sectionData } = this.props;
    if (sectionData) {
      const configApi = sectionData.configApi;
      const dataApi = sectionData.dataApi;
      const dependentsApi = sectionData.dependentsApi;
      let queue: any[] = [];

      let dataProm: Promise<any>;
      if (dataApi.isListData) {
        dataProm = this.context.listData(dataApi.defnId, AppType.Assortment, dataApi.params).then((resp) => {
          return resp.flat;
        });
      } else {
        const dataUrl = getUrl(dataApi);
        dataProm = Axios.get(dataUrl).then((response) => {
          let rowData = response.data ? response.data : response;
          if (!isArray(rowData)) {
            rowData = rowData.data;

            // need to flatten rangingParams data which returns as an object
            // with keys as floorset groups and values as an array of store items
            if (sectionData?.rowGroupDataIndex) {
              const flattenedRowData = reduce(rowData, (acc, floorsetItems) => concat(acc, floorsetItems), [] as any[]);
              rowData = flattenedRowData;
            }
          }
          return rowData;
        });
      }

      queue = [dataProm, getViewProm(configApi), getRangeLists()];

      if (dependentsApi) {
        queue = [...queue, Axios.get(dependentsApi.url)];
      }

      Promise.all(queue).then((response: any) => {
        if (!this._isMounted) {
          return;
        }

        const { daysRangeListExtended: daysRangeList, daysPastRangeList } = response[2];
        const mergedRangeList = {
          start_date: merge(daysRangeList.start_date, daysPastRangeList.start_date),
          end_date: merge(daysRangeList.end_date, daysPastRangeList.end_date),
        };
        importDateFunctions(this.math, mergedRangeList);
        this.setState({
          mergedRangeList,
        });

        let rowData = response[0];
        if (!isArray(rowData)) {
          rowData = rowData.data;
        }

        const config = maybeReturnNestData(response[1]) as any;

        this.transposeRowsAndColumns(
          rowData,
          config.columns,
          config.actions,
          config.multiRangeEditors,
          dependentsApi ? response[3].data.data : null,
          this.props.sectionData?.rowGroupDataIndex ?? null,
        );

        if (this.props.onSectionDataLoaded) {
          this.props.onSectionDataLoaded();
        }
      });
    }
  }

  handleMultiSection() {
    const { multiSectionData } = this.props;

    if (!isNil(multiSectionData)) {
      const { data: rowData, config } = multiSectionData;
      const modified = this.regulateData(rowData);

      if (isNil(modified) || isNil(config)) {
        return;
      }

      this.transposeRowsAndColumns(modified, config.columns, config.actions, config.multiRangeEditors, null, null);

      if (this.props.onSectionDataLoaded) {
        this.props.onSectionDataLoaded();
      }
    }
  }

  /** Fills in blank stylecolor data to match the count of stylecolor data for the style */
  regulateData(data: any, group?: string) {
    const { allStyleColors, sectionData } = this.props;
    const rowGroupDataIndex = sectionData?.rowGroupDataIndex ?? '';
    const modified = allStyleColors
      .map((sc) => sc.id ?? sc.product)
      .map((styleColorId) => {
        const rowDataIndex = data.findIndex((item: any) => {
          return styleColorId === item.id || styleColorId === item.product;
        });

        return rowDataIndex < 0
          ? {
              id: styleColorId,
              [NOT_FOUND]: NOT_FOUND,
              ...(isNil(this.props.sectionData?.rowGroupDataIndex) ? undefined : { [rowGroupDataIndex]: group ?? '' }),
            } // fill in with known empty data
          : data[rowDataIndex];
      });

    return modified;
  }

  addColor = async () => {
    const { existingStyleColors, showOnlyPreexist, styleId } = this.props;
    const { actions } = this.state;
    // Open the color modal immediately, then load options
    this.setState({
      availableColorsToAdd: undefined,
      selectedNewColor: undefined,
      addColorModalOpen: true,
    });

    if (!isNil(actions?.addColorFetch)) {
      const listDataConfig = {
        defnId: actions?.addColorFetch.defnId,
        params: {
          topMembers: styleId,
        },
      };
      const colorList = await ServiceContainer.pivotService
        .listData(listDataConfig.defnId, undefined, listDataConfig.params)
        .then((colors) => {
          const retZod = z.array(z.object({ value: z.string(), existing: z.number() }));
          return retZod.parse(colors.tree).map((i) => ({
            value: i.value,
            existing: i.existing,
          }));
        });
      this.setState({
        availableColorsToAdd: colorList,
        selectedNewColor: colorList[0].value,
      });
    } else {
      let colorList = getExistingColorsNotInAsst(existingStyleColors).map((i) => ({
        value: i,
        existing: 1,
      }));
      if (!showOnlyPreexist) {
        const nonExistingColors = (await getAllColors(styleId)).map((color) => {
          return {
            value: color,
            existing: 0,
          };
        });
        colorList = nonExistingColors.concat(colorList);
      }
      this.setState({
        availableColorsToAdd: colorList,
        selectedNewColor: colorList[0].value,
      });
    }
  };

  removeColor(styleColorId: string) {
    const { sortedStyleColorIds, refresh } = this.props;
    const refreshCompanionView = sortedStyleColorIds.length === 1; // removing last style color from style

    return removeStyleColor(styleColorId)
      .then((resp: any) => {
        // for some reason the error handler is not invoked, so checking here for success
        const expectedErrorMsg = 'StyleColor is not removable from Assortment';
        if (!resp.data.success && resp.data.message === expectedErrorMsg) {
          toast.error(`This style color has already been published \ and cannot be removed from Assortment.`, {
            position: toast.POSITION.TOP_LEFT,
          });
        }

        if (refresh) {
          refresh(refreshCompanionView);
        }
      })
      .catch((err) => {
        toast.error(`An unexpected error occured while attempting to remove a color from the assortment`, {
          position: toast.POSITION.TOP_LEFT,
        });
        ServiceContainer.loggingService.error(
          `An error occured removing ${styleColorId} from the assortment`,
          err.stack,
        );
      });
  }

  reorderAndFilterColumns(gridApi: AgGrid.GridApi) {
    if (isNil(gridApi) || !this.state.rowData || isNil(gridApi.getColumns())) {
      return;
    }

    const { sortedStyleColorIds } = this.props;
    const { rowData } = this.state;
    const allIds = rowData.map((data: any) => data.id ?? data.product).filter((item) => item !== undefined);
    const columns = gridApi.getColumns();
    // hide all columns then show filtered columns | Also check if column count in grid is same or larger than new columns
    if (!isNil(columns) && columns.length - 1 >= sortedStyleColorIds.length) {
      gridApi.setColumnsVisible(allIds, false);
      gridApi.setColumnsVisible(sortedStyleColorIds, true);
      gridApi.moveColumns(sortedStyleColorIds, 0);
    }
  }

  doesExternalFilterPass(node: IRowNode): boolean {
    return !node.data.hidden;
  }

  private setDisabledId = (id: string, group?: string): void => {
    const refreshCols = () => {
      if (this.gridApi) {
        this.gridApi.refreshCells({
          columns: [id],
          // force: true,
        });
      }
    };

    const disableId = { colId: id, groupId: group };
    const hasDisabledId = this.state.disabledIds.find((i) => isEqual(i, disableId));
    if (!hasDisabledId) {
      this.setState(
        (prevState) => ({
          disabledIds: prevState.disabledIds.concat([{ colId: id, groupId: group }]),
        }),
        refreshCols,
      );
    }
  };

  private removeDisabledId = (id: string, group?: string): void => {
    const refreshCols = () => {
      if (this.gridApi) {
        this.gridApi.refreshCells({
          columns: [id],
          // force: true,
        });
      }
    };

    const disabledId = { colId: id, groupId: group };
    const hasDisabledId = this.state.disabledIds.find((i) => isEqual(i, disabledId));
    if (hasDisabledId) {
      this.setState(
        (prevState) => ({
          disabledIds: filter(prevState.disabledIds, (i) => !isEqual(i, disabledId)),
        }),
        refreshCols,
      );
    }
  };

  private columnDisabled = (id: string, group?: string | null): boolean => {
    const disabledId = { colId: id, groupId: group };
    return this.state.disabledIds.find((i) => isEqual(i, disabledId)) != null;
  };

  private setDisabledIds(
    colDefs: (StyleEditConfigColumn | ColorHeaderConfigColumn)[],
    styleColor: BasicPivotItem,
    styleColorId: string,
  ) {
    colDefs.forEach((col: StyleEditConfigColumn) => {
      if (col.controlsColumnDisable) {
        const disableColumn = col.controlColumnDisableValue === styleColor[col.dataIndex];
        const groupKey = this.props.sectionData?.rowGroupDataIndex;
        const group = groupKey ? styleColor[groupKey] : null;
        if (disableColumn) {
          this.setDisabledId(styleColorId, group);
        } else {
          this.removeDisabledId(styleColorId, group);
        }
      }
    });
  }

  createColumn = (
    colDefs: (StyleEditConfigColumn | ColorHeaderConfigColumn)[],
    itemId: string,
    getStyleColorData: (groupId: string, itemId: string) => BasicPivotItem | undefined,
  ): ColDef => {
    const inlineEditors = ['validSizes', 'checkbox'];
    const styleColorId = itemId;

    const numRows = colDefs.length - 1; // 1 less because title
    function getNotInLifecycleText(numRow: number, rowIndex: number): string {
      let totalRows = numRow;
      if (totalRows % 2 === 0) {
        totalRows = totalRows - 1;
      }
      const tempNo = (totalRows - 3) / 2;
      const firstIndex = tempNo,
        secondIndex = tempNo + 1,
        thirdIndex = tempNo + 2;
      if (rowIndex === firstIndex) {
        return 'NOT IN';
      }
      if (rowIndex === secondIndex) {
        return 'LIFECYCLE';
      }
      if (rowIndex === thirdIndex) {
        return 'RANGE';
      }
      return '';
    }

    const notInLifecycleRange = (colInfo: StyleEditConfigColumn, styleColor: BasicPivotItem | undefined): boolean => {
      return colInfo.dataIndex !== 'color_header' && styleColor && styleColor[NOT_FOUND];
    };

    const isInitialFundedFloorset = (
      colInfo: StyleEditConfigColumn,
      styleColor: BasicPivotItem | undefined,
    ): boolean => {
      return colInfo.dataIndex === FUNDED && styleColor && styleColor['isFirstFloorset'];
    };
    // helper for progress check
    const isCellAsyncInProgress = (node: AgGrid.IRowNode | undefined, colInfo?: any) => {
      if (!node || !colInfo) return false;
      const state = getCellAsyncState(node, colInfo);
      return state === AsyncCellState.Processing || state === AsyncCellState.Redecorating;
    };

    const isEditable = (params: AgGrid.ICellEditorParams | AgGrid.ICellRendererParams) => {
      const rowIndex = colDefs.findIndex((def) => {
        return def.dataIndex === last(split(params.node?.id, '$$'));
      });
      const colInfo = colDefs[rowIndex];
      if (colInfo == null) {
        return false;
      }

      // block while async work is happening
      if (isCellAsyncInProgress(params.node, colInfo)) return false;

      const styleColor = getStyleColorData(params.node.parent?.key ?? '', params.colDef?.field ?? '');

      if (colInfo) {
        if (!isNil(colInfo.editableByCalc)) {
          const groupId = params.node?.parent?.key;
          const getDataFn = partial(getDataFromKey, [params, groupId]);
          const calcEditable = !!executeCalculation(this.math, colInfo.editableByCalc, getDataFn);
          return colInfo.editable && calcEditable;
        } else if ((LOCKED_AFTER_COLOR_SUBMIT as ReadonlyArray<string>).indexOf(colInfo.dataIndex) >= 0) {
          return colInfo.editable && this.state.submittedStyleColors.indexOf(styleColorId) < 0;
        } else if (isInitialFundedFloorset(colInfo, styleColor)) {
          return false;
        }

        return colInfo.editable;
      } else {
        return false;
      }
    };

    const isColumnDisabled = (colInfo: StyleEditConfigColumn, params: AgGrid.EditableCallbackParams) => {
      if (isNil(colInfo.renderer) || colInfo.renderer === 'color_header') {
        return false;
      }

      const styleColor = getStyleColorData(params.node.parent?.key ?? '', params.colDef?.field ?? '');
      if (isInitialFundedFloorset(colInfo, styleColor)) {
        return true;
      }
      const group = params.node?.parent?.key;

      // if prop exists and it's value is true (should be for funded only),
      // don't disable otherwise check if styleColorId is disabled
      return colInfo.controlsColumnDisable ? false : this.columnDisabled(styleColorId, group);
    };

    // check for and set disabled columns on load
    // FIXME: can I do outside of createColumn, it's global
    // this.setDisabledIds(colDefs, styleColor, styleColorId);

    const headerComponentParams = this.props.multiSectionData
      ? null
      : {
          $selector: () => {
            return mapValues((colDefs[0] as ColorHeaderConfigColumn).$selector, (value) => {
              return this.props.headerData ? get(this.props.headerData, [styleColorId, value]) : styleColorId;
            }) as SwatchSelector;
          },
          id: styleColorId,
          canRemove: (id: string) => {
            const colorData = get(this.props.headerData, id);
            return colorData?.isremovable === true;
          },
          displayRemove: (colDefs[0] as ColorHeaderConfigColumn).displayRemove, // handles rendering the 'Remove' button
          removeClicked: (_styleColorId: string, description: string) => {
            this.setState({
              confirmationModalProps: {
                isOpen: true,
                descriptionText: `Remove StyleColor ${description}?`,
                onConfirm: () => {
                  this.removeColor(styleColorId).then(() => this.closeConfirmationModal());
                },
                onCancel: () => {
                  this.closeConfirmationModal();
                },
              },
            });
          },
        };

    const cellClassFunction = (params: any, renderer: string) => {
      if (params.colDef.renderer === renderer || params.colDef.cellRenderer === renderer) {
        return true;
      } else if (params.column.getId() !== 'ag-Grid-AutoColumn') {
        return (
          (params.node.data && params.node.data.renderer === renderer) ||
          (params.node.data && params.node.data.formatter === renderer)
        );
      }
      return false;
    };
    const exportOptions = this.getExportOptions();
    //@ts-ignore
    const excelRendererArr: ExcelStyle[] = Object.entries(exportOptions.excelRendererObj || {}).map(([key, value]) => ({
      ...value,
      numberFormat: { format: value.numberFormat },
    }));

    const cellClassRules = excelRendererArr.reduce(
      (accumeObj, style) => {
        const styleId = style.id;
        if (styleId) {
          accumeObj[styleId] = (params: any) => cellClassFunction(params, styleId);
        }
        return accumeObj;
      },
      {} as Record<string, any>,
    );

    return {
      headerName: styleColorId,
      field: styleColorId,
      cellStyle: { borderRight: '1px solid #dee1e6' },
      cellClassRules: {
        ...cellClassRules,
        [StyleEditSectionStyles.editableCell]: (params: CellClassParams) => {
          const rowIndex = colDefs.findIndex((def) => {
            return def.dataIndex === last(split(params.node.id, '$$'));
          });
          const colInfo = colDefs[rowIndex];
          const styleColor = getStyleColorData(params.node.parent?.key ?? '', params.colDef?.field ?? '');
          if (
            isNil(colInfo) ||
            isNil(styleColor) ||
            notInLifecycleRange(colInfo, styleColor) ||
            isInitialFundedFloorset(colInfo, styleColor)
          ) {
            return false;
          }
          if ((LOCKED_AFTER_COLOR_SUBMIT as ReadonlyArray<string>).indexOf(colInfo.dataIndex) >= 0) {
            return colInfo.editable && this.state.submittedStyleColors.indexOf(styleColorId) < 0;
          }
          let calcEditValid = true;
          const groupId = params.node?.parent?.key;
          if (!isNil(colInfo.editableByCalc)) {
            const getDataFn = partial(getDataFromKey, [params, groupId]);
            calcEditValid = !!executeCalculation(this.math, colInfo.editableByCalc, getDataFn);
          }

          return calcEditValid && colInfo.editable && !this.columnDisabled(styleColorId, groupId);
        },
        [StyleEditSectionStyles.cellDisabled]: (params: CellClassParams) => {
          const rowIndex = colDefs.findIndex((def) => {
            return def.dataIndex === last(split(params.node.id, '$$'));
          });
          const colInfo = colDefs[rowIndex];
          if (isNil(colInfo)) {
            return false;
          }

          return isColumnDisabled(colInfo, params);
        },
        [StyleEditSectionStyles.notInLifecycle]: (params: CellClassParams) => {
          const rowIndex = colDefs.findIndex((def) => {
            return def.dataIndex === last(split(params.node.id, '$$'));
          });
          const colInfo = colDefs[rowIndex];
          const styleColor = getStyleColorData(params.node.parent?.key ?? '', params.colDef?.field ?? '');

          if (isNil(colInfo) || isNil(styleColor)) {
            return false;
          }

          return notInLifecycleRange(colInfo, styleColor);
        },
        loading: (p: CellClassParams) => {
          const colKey = p.data?.dataKey;
          return getCellAsyncState(p.node, { dataIndex: colKey }) === AsyncCellState.Processing;
        },
        redecorating: (p: CellClassParams) => {
          const colKey = p.data?.dataKey;
          return getCellAsyncState(p.node, { dataIndex: colKey }) === AsyncCellState.Redecorating;
        },
      },
      suppressKeyboardEvent: (params) => {
        const rowIndex = colDefs.findIndex((def) => def.dataIndex === params.data?.dataKey);
        const colInfo = colDefs[rowIndex];
        const inputType = colInfo?.inputType;

        if (inputType && (BLOCK_ENTER_EDITORS as ReadonlyArray<string>).includes(inputType)) {
          if (params.editing && (POPOVER_BLOCK_CODES as ReadonlyArray<string>).includes(params.event.code)) {
            return true;
          }
        }
        return false;
      },
      onCellValueChanged: (params: ValueSetterParams) => {
        this.handleCellValueChange(styleColorId, params, colDefs, getStyleColorData);
      },
      valueGetter: (params: AgGrid.ValueGetterParams) => {
        const { colDef, data, node } = params;

        if (isNil(data)) {
          return null;
        }

        const calculation = data.calculation;
        const groupId = params.node?.parent ? params.node.parent.key : null;
        const getDataFn = partial(getDataFromKey, [params, groupId]);
        const rowIndex = colDefs.findIndex((def) => {
          return def.dataIndex === node?.id;
        });
        const colInfo = colDefs[rowIndex];
        const colValue = data[styleColorId];

        if (
          colInfo != null &&
          colInfo.dataIndex !== 'color_header' &&
          (isNil(colInfo.editable) || colInfo.editable === false) &&
          isNil(colValue)
        ) {
          return null;
        }

        if (calculation) {
          if (data.onlyCalcOnParamChange) {
            // If dependent params of calculation have changed from original, process calcs
            let paramChangedCalc = false;
            const vars = getVarsFromCalcString(this.math, calculation);
            vars.forEach((v: string) => {
              const varValue = getDataFn(v)?.data;
              const columnField = colDef.field;
              if (columnField) {
                if (Object.keys(this.savedCalcData).indexOf(columnField) === -1) {
                  this.savedCalcData[columnField] = {};
                }
                if (Object.keys(this.savedCalcData[columnField]).indexOf(v) === -1) {
                  this.savedCalcData[columnField][v] = varValue;
                }
                if (!isEqual(varValue, this.savedCalcData[columnField][v])) {
                  paramChangedCalc = true;
                }
              }
            });
            if (!paramChangedCalc) {
              return data[styleColorId];
            }
          }
          // @ts-ignore - this would not work with a condition check
          const newValue = executeCalculation(this.math, calculation, getDataFn);
          return newValue;
        } else {
          const value = data[styleColorId];

          if (!isNil(colInfo) && !isNil(value) && colInfo.renderer === 'percent') {
            const parsedValue = parseFloat(value);
            // if editing, show non-decimal value (0.11 => 11) otherwise percent renderer will format properly
            return parsedValue;
          }

          // If value is undefined or comes back as string "undefined", make it an empty string
          if (isNil(value) || Number.isNaN(value) || toString(value).trim() === 'undefined') {
            return '';
          }

          return value;
        }
      },
      valueSetter: (params: ValueSetterParams) => {
        this.handleSetValue(styleColorId, this.state.dependentData, params);
        return true;
      },
      editable: (params) => {
        const rowIndex = colDefs.findIndex((def) => {
          return def.dataIndex === last(split(params.node.id, '$$'));
        });
        let isSubmitLocked = false;
        const colInfo = colDefs[rowIndex];
        const styleColor = getStyleColorData(params.node.parent?.key ?? '', params.colDef?.field ?? '');
        if (isCellAsyncInProgress(params.node, colInfo)) return false;

        if (
          isNil(colInfo) ||
          isNil(styleColor) ||
          notInLifecycleRange(colInfo, styleColor) ||
          isInitialFundedFloorset(colInfo, styleColor)
        ) {
          return false;
        }
        if ((LOCKED_AFTER_COLOR_SUBMIT as ReadonlyArray<string>).indexOf(colInfo.dataIndex) >= 0) {
          isSubmitLocked = this.state.submittedStyleColors.indexOf(styleColorId) >= 0;
        }
        let calcEditValid = true;
        if (!isNil(colInfo.editableByCalc)) {
          const groupId = params.node?.parent?.key;
          const getDataFn = partial(getDataFromKey, [params, groupId]);
          calcEditValid = !!executeCalculation(this.math, colInfo.editableByCalc, getDataFn);
        }
        const canEdit = !isNil(colInfo.editable) ? colInfo.editable : false;
        const isDisabled = isColumnDisabled(colInfo, params);
        // Skip inputType check only for 'checkbox'; still require it for 'validSizes'
        const isInlineEditor =
          colInfo.renderer &&
          inlineEditors.indexOf(colInfo.renderer) >= 0 &&
          (colInfo.renderer === 'checkbox' || isNil(colInfo.inputType));

        return canEdit && calcEditValid && !isDisabled && !isInlineEditor && !isSubmitLocked;
      },
      cellEditorSelector: (params: AgGrid.ICellEditorParams): CellEditorSelectorResult => {
        const styleColor = getStyleColorData(params.node.parent?.key ?? '', params.colDef.field ?? '');
        const rowIndex = colDefs.findIndex((def) => {
          return def.dataIndex === last(split(params.node.id, '$$'));
        });
        const colInfo = colDefs[rowIndex];
        if (colInfo == null || isNil(styleColor)) {
          return null as unknown as CellEditorSelectorResult;
        }
        const inputParams = colInfo.inputParams;

        switch (colInfo.inputType) {
          case 'select':
            return {
              component: 'agRichSelect',
              params: {
                values: map('value', colInfo.options),
              },
            };
          case 'multiRangeEditors':
            params.colDef.cellEditorPopup = true;

            const { disableOverlap } = colInfo;
            const { multiRangeEditors } = this.state;
            const multiRangeDataIndices =
              !isNil(multiRangeEditors) && !isNil(colInfo.inputComponent)
                ? // @ts-expect-error
                  multiRangeEditors[colInfo.inputComponent]
                : {};
            const checkboxIndices = !isNil(multiRangeEditors) ? multiRangeEditors.checkboxEditor : undefined;
            const col = colInfo.dataIndex;
            return {
              component: 'rangePickerEditor',
              params: {
                values: map('value', colInfo.options),
                nodeKey: params.data?.dataKey,
                makeModal: true,
                multiRangeDataIndices,
                disableOverlap,
                startWithPlanCurrent: true,
                checkboxIndices,
                lifecycleData: styleColor,
                updateLifecycleData: async (styleColorId: string, newValue: { [s: string]: any }) => {
                  const { node, column } = params;
                  if (node && column) {
                    this.applyAsyncState([params.node], [params.column], AsyncCellState.Processing);
                  }
                  const res = await updateLifecycleParams(styleColorId, newValue);
                  // clear caches so redecorate pulls fresh values
                  this.context.clearPivotCache?.();
                  if (node && column) {
                    await this.runRedecorate(node, column);
                  }
                  return res;
                },
                col,
              },
            };
          case 'popoverSelect': {
            params.colDef.cellEditorPopup = true;

            const { text: title, inputComponent } = colInfo;
            const processedDataApi = processApiParams(colInfo.dataApi, styleColor);

            return {
              component: 'popoverSelectEditor',
              params: {
                title,
                inputComponent,
                dataApi: processedDataApi,
                makeModal: inputComponent === 'ssgSelect',
              },
            };
          }
          case 'validValues':
          case 'validValuesMulti': {
            params.colDef.cellEditorPopup = true;
            const multiSelect = colInfo.inputType === 'validValuesMulti' ? true : undefined;
            const allowEmptyOption = isNil(colInfo.allowEmptyOption) ? true : colInfo.allowEmptyOption;
            let processedDataApi;
            let clientHandler;

            if (isNil(colInfo.dataApi.clientHandler)) {
              const field = params.colDef.field;
              if (!isUndefined(colInfo.dataApi.params) && colInfo.observes && params.node.parent && field) {
                const rowData = params.node.parent.allLeafChildren.find(
                  (row: IRowNode) => row.data?.dataKey === colInfo.observes,
                );
                const rowId = rowData?.data[field];

                // The entire createColumn() function is created within a closer, with the assignment of
                // 'styleColor' at the top.
                // In the specific case of a column that observes another column, the styleColor becomes
                // out of date after an edit (because the column hasn't been recreated yet),
                // and therefore doesn't have the latest data.  An attempt was made to get the latest data from
                // this.state.rowData but that was also inexplicably stale,
                // so here we glue on the latest data from the transposed grid, and generate
                // a processed Api from that
                const latestStyleColorData = {
                  ...styleColor,
                  [colInfo.observes]: rowId,
                };
                processedDataApi = processApiParams(colInfo.dataApi, latestStyleColorData);
              } else {
                processedDataApi = processApiParams(colInfo.dataApi, styleColor);
              }
            } else if (colInfo.dataApi.clientHandlerParams) {
              const clientHandlerParams = (this.props as Record<string, any>)[colInfo.dataApi.clientHandlerParams];
              clientHandler = getClientHandler(colInfo.dataApi.clientHandler, clientHandlerParams);
            }
            return {
              component: 'validValuesEditor',
              params: {
                dataConfig: processedDataApi,
                clientHandler,
                dataQa: isNil(multiSelect) ? 'select-style-edit-section' : 'select-multi-style-edit-section',
                multiSelect,
                asCsv: colInfo.asCsv,
                ignoreCache: colInfo.ignoreCache,
                allowEmptyOption,
                includeCurrent: colInfo.includeCurrent,
              },
            };
          }
          case 'validValuesNoServer': {
            const { dependentData } = this.state;
            return {
              component: 'validValuesEditor',
              params: {
                options: !isNil(dependentData) ? Object.keys(dependentData) : [],
                dataQa: 'select-no-server-editor',
              },
            };
          }
          case 'validSizes': {
            params.colDef.cellEditorPopup = !isNil(colInfo.inputType);
            const { dependentData } = this.state;

            if (colInfo.dataApi) {
              // allow component to manage own data
              const dataParams = colInfo.dataApi.params;
              const transposedData: Record<string, unknown> = {};
              if (dataParams != null) {
                Object.values(dataParams).forEach((valKey) => {
                  const rowNode = params.api.getRowNode(valKey);
                  if (rowNode != null) {
                    transposedData[valKey] = rowNode.data[styleColorId];
                  }
                });
              }
              const validSizesDataApi = processApiParams(colInfo.dataApi, transposedData);
              return {
                component: 'validSizesEditor',
                params: {
                  dataApi: validSizesDataApi,
                  selectedOptions: params.data[styleColorId],
                  editable: isEditable(params),
                },
              };
            } else {
              const rangeCode = params.api.getRowNode(RANGE_CODE)?.data[styleColorId];
              const dependentSizes = !isNil(dependentData) && rangeCode ? dependentData[rangeCode] : null;
              const selectedOptions = !isNil(dependentSizes) ? dependentSizes : params.data[styleColorId];
              return {
                component: 'validSizesEditor',
                params: {
                  options: dependentSizes,
                  selectedOptions,
                  editable: isEditable(params),
                },
              };
            }
          }
          case 'checkbox':
            return {
              component: 'checkboxCellRenderer',
              params: {
                isEditable: isEditable(params),
              },
            };
          case 'usMoney':
          case 'thousand':
          case 'usMoneyRounded':
          case 'usMoneyNoCents':
            return {
              component: 'nonFrameWorkToS5Renderer',
              params: {
                inputType: 'percent',
              },
            };
          case 'percent':
          case 'integer':
            const percent = colInfo.renderer === 'percent';
            return {
              component: 'integerEditor',
              params: {
                inputParams: { ...inputParams, percent },
              },
            };
          case 'textValidator':
          case 'textValidatorAsync': {
            params.colDef.cellEditorPopup = true;

            const whitelist = viewDefnWhitelistToNarrowedCharacterWhitelist(inputParams.whitelist);

            return {
              component: 'textValidationEditor',
              params: {
                validateAsync: colInfo.inputType === 'textValidatorAsync',
                ...inputParams,
                whitelist,
                onValidated: this.handlePendingCellUpdate.bind(this), // will be invoked in promise context, so need to set context
              },
            };
          }
          default:
            return {
              component: 'agTextCellEditor',
            };
        }
      },
      cellRendererSelector: (params: AgGrid.ICellRendererParams): CellRendererSelectorResult => {
        const rowIndex = colDefs.findIndex((def) => {
          return def.dataIndex === params.data?.dataKey;
        });
        const colInfo = colDefs[rowIndex];
        const styleColor = getStyleColorData(params.node.parent?.key ?? '', params.colDef?.field ?? '');

        if (colInfo == null || isNil(styleColor)) {
          return null as unknown as CellRendererSelectorResult;
        }

        if (notInLifecycleRange(colInfo, styleColor)) {
          return {
            component: 'notInLifecycle',
            params: {
              text: getNotInLifecycleText(numRows, rowIndex - 1),
            },
          };
        }

        switch (colInfo.renderer) {
          case 'image':
            return {
              component: 'imageCellRenderer',
              params: {
                showEditButton: true,
              },
            };
          case 'icon':
            return {
              component: 'iconCellRenderer',
              params: {
                icon: colInfo.rendererIcon,
              },
            };
          case 'csv':
            return {
              component: (params: { value: unknown }) => {
                let contents: unknown;
                if (isArray(params.value)) {
                  contents = params.value.join(', ');
                } else {
                  contents = params.value;
                }
                return <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>{contents}</div>;
              },
            };
          case 'color_header':
            /** Used for remove color modal, as a way to use `ColorHeaderRenderer`'s `SwatchSelector` properties
             * (the configurable property for that component, but internal only) in the closure here */
            const outerColorHeaderSelector: Record<string, string> = {};

            const infoAsColorHeader = colInfo as ColorHeaderConfigColumn;
            const isRemovable = get(this.props.headerData, [styleColorId, 'isremovable']) === true;
            const colorHeadParams = {
              $selector: () => {
                return mapValues(infoAsColorHeader.$selector, (value, key) => {
                  // the `isNil` check below is where colors that are in `headerData` are filtered out in a section that
                  // that doesn't appear in the current `StyleEditSection`
                  if (this.props.headerData && !isNil(this.props.headerData[styleColorId])) {
                    const itemData = this.props.headerData[styleColorId];
                    const itemDataValue = itemData[value] ? itemData[value] : undefined;
                    outerColorHeaderSelector[key] = itemDataValue;
                    return itemDataValue;
                  } else {
                    styleColor[value];
                  }
                }) as SwatchSelector;
              },
              id: styleColorId,
              canRemove: (id: string) => {
                const colorData = get(this.props.headerData, id);
                return colorData?.isremovable === true;
              },
              displayRemove: infoAsColorHeader.displayRemove, // handles rendering the 'Remove' button
              removeClicked: () => {
                const descriptionText = outerColorHeaderSelector.description || styleColor.description;
                this.setState({
                  confirmationModalProps: {
                    isOpen: true,
                    descriptionText: `Remove Style Color ${descriptionText}?`,
                    onConfirm: () => {
                      this.removeColor(styleColorId).then(() => this.closeConfirmationModal());
                    },
                    onCancel: () => {
                      this.closeConfirmationModal();
                    },
                  },
                });
              },
            };

            return {
              component: 'colorHeaderCellRenderer',
              params: colorHeadParams,
            };
          case 'checkbox':
            return {
              component: 'checkboxCellRenderer',
              params: {
                isEditable: isEditable(params),
              },
            };
          case 'range_picker':
            return {
              component: 'rangePickerRenderer',
            };
          case 'validSizes':
            const { dependentData } = this.state;
            if (!params.api) {
              // this block attempts to catch rare async errors that can occur when the section is
              // mounted and unmounted rapidly, causing a throw on params.api
              // if no api is found, dump the sections
              // see INT-1241
              this.props.refreshSections(null);
              return {
                component: 'nonFrameWorkToS5Renderer',
                params: {
                  renderer: colInfo.renderer,
                },
              };
            }
            if (colInfo.dataApi) {
              // allow component to manage own data
              const dataParams = colInfo.dataApi.params;
              const transposedData: Record<string, unknown> = {};
              if (dataParams != null) {
                Object.values(dataParams).forEach((valKey) => {
                  const rowNode = params.api.getRowNode(valKey);
                  if (rowNode != null) {
                    transposedData[valKey] = rowNode.data[styleColorId];
                  }
                });
              }
              const validSizesDataApi = processApiParams(colInfo.dataApi, transposedData);
              return {
                component: 'validSizesRenderer',
                params: {
                  selectedOptions: params.data[styleColorId],
                  options: [],
                  dataApi: validSizesDataApi,
                  editable: isEditable(params),
                  cursorStyle: 'pointer',
                },
              };
            } else {
              const rangeCode = params.api.getRowNode(RANGE_CODE)?.data[styleColorId];
              const dependentSizes = !isNil(dependentData) && rangeCode ? dependentData[rangeCode] : null;
              const options = !isNil(dependentSizes) ? dependentSizes : params.data[styleColorId];
              return {
                component: 'validSizesRenderer',
                params: {
                  options,
                  editable: isEditable(params),
                },
              };
            }
          case 'validValuesMultiLine':
            return {
              component: 'validSizesRenderer',
              params: {
                editable: false,
                cursorStyle: 'cursor',
              },
            };
          case 'validValuesRenderer':
            const dataConfig = processApiParams(colInfo.dataApi, styleColor);
            return {
              component: 'validValuesRenderer',
              params: {
                dataConfig,
              },
            };
          case 'clearValue':
            return {
              component: 'clearValueRenderer',
              params: {
                isDataTransposed: true,
              },
            };
          case 'modalLink':
            return {
              component: 'modalLinkRenderer',
              params: {
                displayValue: 'View Similar Items',
                isDataTransposed: true,
                modalParams: colInfo.inputParams,
                getValue: this.getOriginalValue,
              },
            };
          case 'tooltipRenderer':
            return {
              component: 'tooltipRenderer',
            };
          default:
            return {
              component: 'nonFrameWorkToS5Renderer',
              params: {
                renderer: colInfo.renderer,
              },
            };
        }
      },
      headerComponentParams,
    };
  };

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalProps: {
        isOpen: false,
        descriptionText: '',
      },
    });
  };

  createRow = (rowData: any, rowGroupDataIndex: string | null, colDef: any): TransposedColDef => {
    // setup observers if applicable
    const observed = get(colDef, 'observes'); // get observed props from current colDef
    const observer = get(colDef, 'dataIndex');
    if (!isNil(observer) && !isNil(observed)) {
      if (isNil(this.observers[observed])) {
        this.observers[observed] = {
          [observer]: { dataApi: colDef.dataApi },
        };
      } else {
        const existingObservers = this.observers[observed];
        this.observers[observed] = {
          ...existingObservers,
          [observer]: { dataApi: colDef.dataApi },
        };
      }
    }

    const data = isArray(rowData) ? rowData : [rowData];
    const baseAccumulator = {
      headerText: colDef.text,
      dataKey: colDef.dataIndex,
      calculation: colDef.calculation,
      valueTests: colDef.valueTests,
      onlyCalcOnParamChange: colDef.onlyCalcOnParamChange,
      hidden: colDef.hidden,
      renderer: colDef.renderer,
    };
    // Col Name | Choice 1 | Choice 2
    // Floor 1
    //   Sls u
    // insert rowGroupDataIndex onto each generated row when provided
    const accumulator = isNil(rowGroupDataIndex)
      ? baseAccumulator
      : {
          ...baseAccumulator,
          [rowGroupDataIndex]: get(data, `[0].${rowGroupDataIndex}`, ''),
        };

    return data.reduce((acc: Record<string, any>, dataItem: any) => {
      const id = dataItem.id || dataItem.product;
      const modifiedRecord = {
        [id]: dataItem[colDef.dataIndex],
        ...acc,
      };
      return modifiedRecord;
    }, accumulator);
  };

  getOriginalValue = (id: string, attrName: string) => {
    const { rowData } = this.state;
    return get(
      find((row) => row.id === id || row.product === id, rowData),
      attrName,
    );
  };

  transposeRowsAndColumns(
    rowData: any,
    colDefs: any,
    actions: any,
    multiRangeEditors: MultiRangeEditors,
    dependents: any = null,
    rowGroupDataIndex: string | null,
  ) {
    const { allStyleColors, multiSectionData, sortedStyleColorIds } = this.props;
    let transposedData: TransposedColDef[];
    let pinnedData: TransposedColDef[] | undefined = undefined;
    let transposedDefs: TransposedColDef[];

    const headerCol: TransposedColDef[] = [
      {
        headerName: '',
        field: 'headerText',
        pinned: 'left',
      },
    ];

    const sortedStyleColors = sortBy(allStyleColors, (d) => {
      const sortIndex = sortedStyleColorIds.indexOf(d.id ?? d.product);
      // We use 1000 for ids not in sorted to push the "hidden" columns to the end just to ensure consistent placement.
      return sortIndex >= 0 ? sortIndex : 1000;
    });

    const createdStyleColors = rowData
      .filter((i: BasicPivotItem) => !isNil(i[COLOR_SUBMITTED_ATTR]) && i[COLOR_SUBMITTED_ATTR] !== 'Undefined')
      .map((i: BasicPivotItem) => i.id ?? i.product);

    // setup disabledIds in state
    rowData.forEach((rd: BasicPivotItem) => this.setDisabledIds(colDefs, rd, rd.id ?? rd.product));

    if (rowGroupDataIndex) {
      const groupingCol: TransposedColDef[] = [
        {
          headerName: rowGroupDataIndex,
          field: rowGroupDataIndex,
          hide: true,
          rowGroup: true,
        },
      ];

      const groupedData = groupBy(rowData, rowGroupDataIndex);

      // insert missing style colors for each group
      const regulatedGroupedData = mapValues(groupedData, (groupItems, group) => this.regulateData(groupItems, group));

      // function to lookup the data for a specific item (i.e. stylecolor) in the specified group (i.e. floorset)
      const getStyleColorDataFromGroup = (group: string, itemId: string) => {
        const groupItems = regulatedGroupedData[group];
        const item = groupItems.find((gi) => {
          const currentItemId = gi.id ?? gi.product;
          return currentItemId === itemId;
        });
        return item;
      };

      transposedData = reduce(
        regulatedGroupedData,
        (acc, groupItems) => {
          const transposed: TransposedColDef[] = colDefs.map(partial(this.createRow, [groupItems, rowGroupDataIndex]));
          return concat(acc, transposed);
        },
        [] as TransposedColDef[],
      );

      const uniqueColumns = sortedStyleColors
        .map((rd) => rd.id || rd.product)
        .map((scid) => this.createColumn(colDefs, scid, getStyleColorDataFromGroup)) as TransposedColDef[];

      transposedDefs = concat(groupingCol, headerCol, uniqueColumns);
    } else if (!isNil(multiSectionData)) {
      // legacy multisection grids
      const maybeRegulatedData = this.regulateData(rowData);
      transposedData = colDefs.map(partial(this.createRow, [maybeRegulatedData, rowGroupDataIndex]));

      const getStyleColorData = (_: string, itemId: string) => {
        const item = maybeRegulatedData.find((gi: any) => {
          const currentItemId = gi.id ?? gi.product;
          return currentItemId === itemId;
        });
        return item;
      };

      const uniqueColumns = sortedStyleColors
        .map((rd) => rd.id || rd.product)
        .map((scid) => this.createColumn(colDefs, scid, getStyleColorData)) as TransposedColDef[];

      transposedDefs = concat(headerCol, uniqueColumns);
    } else {
      // non-grouped grid
      transposedData = colDefs.map(partial(this.createRow, [rowData, rowGroupDataIndex]));

      const getStyleColorData = (_: string, itemId: string) => {
        const item = rowData.find((gi: any) => {
          const currentItemId = gi.id ?? gi.product;
          return currentItemId === itemId;
        });
        return item;
      };

      const uniqueColumns = sortedStyleColors
        .map((rd) => rd.id || rd.product)
        .map((scid) => this.createColumn(colDefs, scid, getStyleColorData)) as TransposedColDef[];

      transposedDefs = concat(headerCol, uniqueColumns);
    }
    // Storing the pinned data for use in the legacy sticky header
    pinnedData = transposedData.filter((td) => td.dataKey === 'color_header');
    // omit the color_header (first item in colDefs) when generating transposed rows
    // to prevent multiple color_header rows from being generated
    transposedData = transposedData.filter((td) => td.dataKey !== 'color_header');
    this.gridApi?.setGridOption('rowData', transposedData);
    this.setState({
      submittedStyleColors: createdStyleColors,
      rowData,
      colDefs,
      actions,
      transposedData,
      pinnedData,
      transposedDefs,
      dependentData: dependents,
      isLoading: null,
      multiRangeEditors,
    });
  }

  handlePendingCellUpdate(value: string, pendingCellInfo: PendingCellInfo) {
    if (!isNil(pendingCellInfo.validation) && !pendingCellInfo.validation.isValid) {
      const { invalidValue, initialValue, invalidLevel } = pendingCellInfo.validation;
      const initial = isNil(initialValue) || isEmpty(initialValue) ? 'Empty' : initialValue;
      const invalidDescription = !isNil(invalidLevel)
        ? `"A value at the style color level was expected, but a ${invalidLevel} was received."`
        : undefined;
      const message = (
        <AsyncValidationErrorMessage
          initial={`"${initial}"`}
          invalidValue={`"${invalidValue}"`}
          invalidDescription={invalidDescription}
        />
      );
      toast.error(message, {
        autoClose: false,
        position: toast.POSITION.TOP_LEFT,
      });
    }
  }

  handleCellValueChange = async (
    styleColorId: string,
    params: ValueSetterParams,
    colDefs: (StyleEditConfigColumn | ColorHeaderConfigColumn)[],
    getStyleColorData: (groupId: string, itemId: string) => BasicPivotItem | undefined,
  ) => {
    const { colDef, data, api: gridApi, oldValue, column } = params;
    const { sectionData } = this.props;
    const newValue = params.newValue;
    const { field } = colDef; // store field (dataKey) of modified column to know which data field to modify
    const { dataKey } = data;
    const observers = this.observers[dataKey]; // get dataKey(s) of row to clear
    const rowIndex = colDefs.findIndex((def) => {
      return def.dataIndex === last(split(params.node?.id, '$$'));
    });
    const colInfo = colDefs[rowIndex];
    const { inputParams, inputType } = colInfo;

    const colKey = data?.dataKey as string | undefined;

    const setAsync = (state: AsyncCellState) => {
      // safety check
      if (!params.node || !colKey) return;
      // if this column opts into a full/section refresh, or if it's not listData,
      // skip individual-cell state updates
      if (colInfo.refreshSectionAfterEdit || !sectionData?.dataApi?.isListData) return;

      // centralized method to set async state on cell
      this.applyAsyncState([params.node], column ? [column] : undefined, state);
    };

    // no need to update; validSizes updates won't pass this check, so always update validSizes
    if (isEqual(oldValue, newValue)) {
      return;
    }

    // cancel the current redecorate, if any
    if (this.redecorateCancel) {
      this.redecorateCancel.cancel('new edit started');
      this.redecorateCancel = undefined;
    }

    if (!isNil(sectionData?.updateCoordinateMap) && !isNil(field)) {
      const coordMap = sectionData?.updateCoordinateMap;
      const coordVals = omitBy(
        mapValues(coordMap, (v) => (colDef as Record<string, any>)[v]),
        isNil,
      );

      const coordRowNode = gridApi.getRowNode(dataKey);
      const coordValue =
        coordRowNode && (gridApi.getValue(column, coordRowNode) ?? this.getOriginalValue(field, dataKey));

      const payload: GranularEditPayloadItem = {
        coordinates: coordVals,
        [dataKey]: coordValue,
      };

      setAsync(AsyncCellState.Processing);

      await submitGranular([payload]);
      // this also needs to be here b/c of the return below
      await this.runRedecorate(params.node, params.column);

      return;
    } else if ((dataKey as string).toLowerCase().indexOf('validsizes') >= 0) {
      // FIXME: This is a mess, however, the server does not currently return arrays as arrays
      // so until that's fixed, we've got to do it this way :/
      if (isEqual(arrayStringToArray(oldValue), arrayStringToArray(newValue))) {
        return;
      }
    } else if (
      colInfo &&
      field &&
      colInfo.inputType === 'textValidatorAsync' &&
      newValue === PENDING_VALIDATION_VALUE
    ) {
      return; // skip posting unvalidated values
    }

    // clear dependentProp fields
    if (!isNil(observers) && !isNil(field)) {
      const styleColor: BasicPivotItem = {} as any;
      if (gridApi) {
        gridApi.forEachNode((rowNode: IRowNode<any>) => {
          styleColor[rowNode.data?.dataKey] = rowNode.data[field];
        });
        gridApi.forEachNode(async (rowNode: IRowNode<any>) => {
          const observer = observers[rowNode.data?.dataKey];

          if (isNil(observer)) {
            return;
          }

          if (observer.dataApi) {
            const api = observer.dataApi as any;
            const url = getUrl(processApiParams(api, styleColor));
            Axios.get(url).then((resp) => {
              if (resp.data && resp.data.data) {
                const respData = resp.data.data;
                const updatedValue =
                  typeof respData[params.newValue] === 'object'
                    ? respData[params.newValue][0]
                    : respData[params.newValue];
                rowNode.setDataValue(field, updatedValue);
              }
            });
          }
        });
      }
    }

    if (!isNil(this.state.actions) && !isNil(this.state.actions.patch) && isNil(sectionData?.updateCoordinateMap)) {
      const { actions } = this.state;
      const { patch } = actions;

      switch (patch.clientHandler) {
        case 'planningParams':
        case 'lifecycleParams':
        case 'adjustments': {
          let updatedValue: string | null;
          if (isNil(newValue)) {
            updatedValue = '';
          } else if ((isNaN(newValue) || newValue === '') && inputType === 'integer' && inputParams?.nullable) {
            updatedValue = null;
          } else if (newValue.weekNo) {
            updatedValue = newValue.weekNo;
          } else {
            updatedValue = newValue;
          }

          if (isNil(colInfo.inputType) || colInfo.inputType !== 'multiRangeEditors') {
            // Some attributes in lifecycle params were trying to post with the attribute: attatched
            const key = dataKey.split(':')[1] || dataKey.split(':')[0];

            setAsync(AsyncCellState.Processing);
            try {
              await updateLifecycleParams(styleColorId, { [key]: updatedValue });
            } catch (e: any) {
              toast.error('An error occured updating your lifecycle parameters');
              ServiceContainer.loggingService.error(
                'An error occured updating the lifecycle parameters in Style edit lifecylce paramters',
                e.stack,
              );
            }
            break;
          }

          // need to calculate necessary fields to post
          const groupId = params.node?.parent?.key;
          const getDataFn = partial(getDataFromKey, [params, groupId]);
          const calculatedFields = colDefs
            .filter((def) => !def.editable && def.calculation)
            .map((def) => {
              return {
                dataIndex: def.dataIndex,
                calculation: def.calculation,
                valueTests: def.valueTests,
              };
            });

          const updates: Record<string, any> = {};
          if (gridApi) {
            calculatedFields.forEach(({ dataIndex, calculation }) => {
              if (calculation) {
                const calculated = executeCalculation(this.math, calculation, getDataFn);
                updates[dataIndex] = calculated;
              }
            });
          }

          const update = {
            [dataKey]: updatedValue,
            ...updates,
          };

          // Send update to rx-js stream
          this.updateItemSubject && this.updateItemSubject.next({ styleColorId, update });
          break;
        }
        case 'colorOptions': {
          const strippedDataKey = dataKey.replace('attribute:', '').replace(':id', '').replace(':name', '');
          const updatedValue = {
            parent: [this.props.styleId],
            id: styleColorId,
            [strippedDataKey]: newValue,
          } as Record<string, any>;

          // need to send cccolorid when cccolor is changed
          // FIXME: This shouldn't be done manually, however, dependents api is returning blank atm.
          if (dataKey === CC_COLOR) {
            updatedValue['cccolorid'] = size(newValue) > 0 ? newValue.split(' ')[0] : '';
          }

          setAsync(AsyncCellState.Processing);
          try {
            await updateStyleItem(updatedValue);
          } catch (e: any) {
            toast.error('An error occured updating your style');
            ServiceContainer.loggingService.error(
              'An error occured updating the style edit in styleeditsection',
              e.stack,
            );
          }

          break;
        }
        case 'rangingParams': {
          const { propagateSelection, multiSectionIndex, multiSectionData, multiSectionLabel } = this.props;
          // don't trigger updates on store_count column, let the propagation handle it itself
          if (dataKey === STORE_COUNT) {
            return;
          }
          // handle forward propagation of data and sending update to server
          if (!isNil(propagateSelection) && !isNil(multiSectionIndex) && multiSectionData) {
            const selection: Record<string, unknown> = {
              id: field,
              dataIndex: dataKey,
              newValue,
              oldValue,
            };
            let calculatedStoreCount = undefined;
            // ssg updates store_count in the handleSetValue function
            // fetch it here and include in propagate (update) call
            const coordRowNode = gridApi.getRowNode(STORE_COUNT);
            if (dataKey === SPECIAL_STORE_GROUP && coordRowNode != null) {
              calculatedStoreCount = gridApi.getValue(column, coordRowNode);
            }
            // determine fields to calculate from config (exclude ssg)
            const toCalculate: string[] = multiSectionData.config.propagatingIndices.filter(
              (dataIndex: string) => dataIndex !== SPECIAL_STORE_GROUP,
            );
            if (toCalculate.indexOf(dataKey) >= 0) {
              // if fields are blank, wait to calculate storeCount until fields are autofilled
              if (newValue.length === 0) {
                // include storecount just in case it's set, let propagate decide whether to use
                await propagateSelection(multiSectionIndex, selection, calculatedStoreCount);
              } else if (toCalculate.indexOf(dataKey) >= 0 && !isNil(this.gridApi) && multiSectionLabel && field) {
                const postData = toCalculate.map((dataIndex) => {
                  if (isNil(this.gridApi)) {
                    throw new Error('Grid api should always exists');
                  }
                  const rowNode = this.gridApi.getRowNode(dataIndex);
                  const rowNodeData = rowNode?.data[field];
                  return { [dataIndex]: rowNodeData };
                });
                await AssortmentClient.calculateStoreCount(styleColorId, multiSectionLabel, postData).then(
                  (calculatedStoreCount) => {
                    return propagateSelection(multiSectionIndex, selection, calculatedStoreCount);
                  },
                );
              }
            } else {
              // include storecount just in case it's set, let propagate decide whether to use
              await propagateSelection(multiSectionIndex, selection, calculatedStoreCount);
            }
          } else {
            const groupId = params.node?.parent?.key ?? '';
            const styleColorData = getStyleColorData(groupId, field ?? '');

            if (isNil(styleColorData)) {
              break;
            }

            const updatedValue = {
              [groupId]: {
                ...styleColorData,
                [dataKey]: newValue,
              },
            };
            setAsync(AsyncCellState.Processing);

            try {
              await updateRangingParams(field ?? '', updatedValue);
            } catch (e: any) {
              toast.error('An error occured updating your lifecycle parameters');
              ServiceContainer.loggingService.error(
                'An error occured updating the lifecycle parameters in Style edit lifecylce paramters',
                e.stack,
              );
            }
          }
          break;
        }
        default:
          noop();
      }
    }
    this.context.clearPivotCache();
    if (colInfo.shouldRefresh === 'full') {
      this.props.refresh();
    } else if (colInfo.shouldRefresh === 'sections') {
      this.props.refreshSections(null);
    } else if (colInfo.refreshSectionAfterEdit) {
      this.getSectionDataAndConfig();
      this.props.refreshSections(this.getComponentId());
    } else {
      this.props.refreshSections(this.getComponentId());
      this.runRedecorate(params.node, params.column);
    }
  };

  handleSetValue = (styleColorId: string, dependentData: DependentData | null, params: ValueSetterParams) => {
    const { data, newValue, api, colDef } = params;

    if (data?.dataKey === SPECIAL_STORE_GROUP && !isNil(this.gridApi)) {
      //this is prevent bug when user open SSG modal and not selecte any SSG
      if (!newValue) {
        data[styleColorId] = null;
        return true;
      }
      // need to get and update store_count too when updating ssg
      const columnKey = colDef.field;
      const storeCountNode = this.gridApi.getRowNode('store_count');
      // update ssg as usual
      if (isArray(newValue)) {
        data[styleColorId] = newValue;
        if (storeCountNode && columnKey) {
          storeCountNode?.setDataValue(columnKey, null);
          this.gridApi.refreshCells();
        }
        return true;
      }
      data[styleColorId] = newValue.id;
      if (storeCountNode && columnKey) {
        storeCountNode.setDataValue(columnKey, newValue.store_count ? newValue.store_count : 0);
        this.gridApi.refreshCells();
      }
      return true;
    }

    if (data?.dataKey !== RANGE_CODE) {
      data[styleColorId] = newValue;
      return true;
    }

    if (api) {
      const rowNodeSizes = api.getRowNode(VALID_SIZES);
      // since getRowNode now returns '| undefined' we need a check for this (v26 typing update)
      if (!isNil(rowNodeSizes)) {
        if (newValue == null) {
          data[styleColorId] = newValue;
          rowNodeSizes.data[styleColorId] = [];
          return true;
        }
        const newValRange = newValue.value ? newValue.value : newValue;
        const newSizeRanges = !isNil(dependentData) ? [...dependentData[newValRange]] : [];

        // Set valid sizes and size range
        rowNodeSizes.data[styleColorId] = newSizeRanges;
        data[styleColorId] = newValRange;
        return true;
      } else return false;
    } else {
      return false;
    }
  };

  handleHeaderGridReady = (headerGridApi: GridApi) => {
    this.headerGridApi = headerGridApi;
    this.reorderAndFilterColumns(this.headerGridApi);
    setGridRowHeights(this.state.colDefs, this.headerGridApi);
  };

  renderAddColorModal = () => {
    const { addColor, existingStyleColors } = this.props;
    const { availableColorsToAdd, isAddingColor, addColorModalOpen, rowData, selectedNewColor } = this.state;

    if (isNil(existingStyleColors) || !addColorModalOpen) {
      return null;
    }
    const DROPDOWN_HEIGHT = 240;
    const isLoadingColors = isUndefined(availableColorsToAdd) || isAddingColor;

    const allColors = availableColorsToAdd ?? [];
    const availColors = allColors;

    const colorOptions = availColors
      .map((color) => {
        const isExisting = color.existing > 0;
        return {
          value: color.value,
          label: `${isExisting ? '*' : ''} ${color.value}`,
          isExisting,
        };
      })
      .sort((a, b) => (a.value > b.value ? 1 : b.value > a.value ? -1 : 0));

    const selectedOption = colorOptions.find((o) => o.value === selectedNewColor) ?? colorOptions[0];
    /** custom loading overlay to render inside the open dropdown */
    const LoadingPaper = (paperProps: any) => (
      <div
        {...paperProps}
        style={{
          ...paperProps.style,
          position: 'relative',
          minHeight: DROPDOWN_HEIGHT,
        }}
      >
        {paperProps.children}
        {isLoadingColors && <Overlay type="loading" visible={true} fitParent={true} />}
      </div>
    );
    return (
      <TemplateModalWithButton
        title="Add New Color"
        buttonComponent={<span style={{ display: 'none' }} />}
        showSubmit={false}
        openOverride={true}
        onCancel={() =>
          this.setState({
            addColorModalOpen: false,
          })
        }
      >
        <div className={''} style={{ width: 200 }}>
          <Autocomplete
            popupIcon={<KeyboardArrowDown />}
            options={colorOptions}
            value={selectedOption}
            getOptionLabel={(option) => option.label || option.value}
            getOptionSelected={(option, value) => option.value === value.value}
            loading={isLoadingColors}
            onChange={(_event, value) => {
              if (value && !isArray(value)) {
                this.setState({
                  selectedNewColor: value.value,
                });
              }
            }}
            open={true}
            forcePopupIcon
            disableClearable
            disablePortal
            PaperComponent={LoadingPaper}
            classes={{
              ...autocompleteStyles(),
              popupIndicator: generalPopupIndicator,
              popperDisablePortal: style({
                position: important('relative'),
              }),
              paper: classes(generalPopper, style({ minHeight: DROPDOWN_HEIGHT })),
              option: StyleEditSectionStyles.autocompleteAddColorOptionStyles,
            }}
            renderOption={renderOption}
            ListboxProps={{
              maxListHeight: DROPDOWN_HEIGHT,
              autoHighlight: false,
              highlightedIndex: -1,
            }}
            ListboxComponent={listBoxVirtualizedWithRef}
            renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Select an option" />}
          />
          <div className={StyleEditSectionStyles.checkboxContainer}>
            <button
              className={StyleEditSectionStyles.iconButtonCancel}
              onClick={() =>
                this.setState({
                  addColorModalOpen: false,
                })
              }
            >
              <Icon className="fal fa-fw fa-2x fa-times" />
            </button>
            <button
              className={StyleEditSectionStyles.iconButtonSave}
              onClick={async () => {
                if (rowData == null || rowData.length <= 0) {
                  this.setState({
                    addColorModalOpen: false,
                  });
                  return;
                }
                this.setState({
                  isAddingColor: true,
                });
                if (addColor && selectedNewColor) {
                  await addColor(
                    selectedNewColor,
                    rowData.find((r: BasicPivotItem) => r.id == this.props.sortedStyleColorIds[0]),
                  );
                }
                this.setState({
                  addColorModalOpen: false,
                  isAddingColor: false,
                });
                this.props.refreshSections(this.getComponentId());
                this.getSectionDataAndConfig();
              }}
            >
              <Icon className="fal fa-2x fa-check" />
            </button>
          </div>
        </div>
      </TemplateModalWithButton>
    );
  };

  //#region AgGridOptions
  // We create AgGridOptions at class level to ensure pointers don't change triggering unnecessary ag-grid render cycles

  getRowId = (params: AgGrid.GetRowIdParams) => {
    let rowPath: string[] = [];
    if (this.props.sectionData?.rowGroupDataIndex) {
      if (params.data) {
        rowPath = [params.data[this.props.sectionData.rowGroupDataIndex], params.data.dataKey];
      } else {
        rowPath = [params.data[this.props.sectionData.rowGroupDataIndex]];
      }
    } else {
      rowPath = [params.data?.dataKey];
    }
    return rowPath.join('$$');
  };

  getRowHeight = (params: RowHeightParams<any, any>): number => {
    if (this.state.colDefs == null) {
      return StyleEditSectionStyles.defaultRowHeight;
    } else if (params.node.group) {
      return StyleEditSectionStyles.defaultGroupRowHeight;
    }

    const def = this.state.colDefs.find((i: any) => i.dataIndex === params.data?.dataKey);
    return getRowHeight(def);
  };

  isExternalFilterPresent = () => true;

  getContextMenuItems = () => {
    return [
      'expandAll',
      'contractAll',
      'copy',
      'resetColumns',
      {
        name: 'CSV Export',
        action: this.onCsvExport,
      },
      {
        name: 'Excel Export',
        action: this.onExcelExport,
      },
    ];
  };

  onGridReady = (params: AgGrid.GridReadyEvent) => {
    if (params.api) {
      this.gridApi = params.api;
      const { colDefs, transposedData, transposedDefs } = this.state;
      setGridRowHeights(colDefs, this.gridApi);

      const columnDefs = transposedDefs;
      const headerGrid = this.props.multiSectionData ? (
        <StyleEditSectionHeaderGrid
          frameworkComponents={this.frameworkComponents}
          nonFrameworkComponents={this.nonFrameworkComponents}
          rowData={this.state.pinnedData}
          columnDefs={columnDefs}
          onHeaderGridReady={this.handleHeaderGridReady}
        />
      ) : null;

      if (headerGrid && this.props.getHeaderElement) {
        this.props.getHeaderElement(headerGrid);
      }
      this.gridApi.setGridOption('columnDefs', this.state.transposedDefs);
      this.gridApi.setGridOption('rowData', this.state.transposedData);
      this.reorderAndFilterColumns(this.gridApi);
      this.gridApi.refreshHeader();
    }
  };

  onCellEditingStopped = (event: AgGrid.CellEditingStoppedEvent) => {
    const { colDef } = event;
    colDef.cellEditorPopup = false;
  };

  private handleProcessCellFromClipboard = (params: ProcessCellForExportParams) => {
    const nodeData = params.node?.data;
    const inputType = nodeData.inputType;

    // If input type is not number, accept the paste as is
    if (inputType !== 'integer') {
      return params.value;
    }

    // If input type is number, process the value
    if (inputType === 'integer') {
      // Strip non-digit and non-period characters from the pasted value
      const cleanedValue = params.value.replace(/[^0-9.]/g, '');
      let parsedValue = parseFloat(cleanedValue);

      // If the parsed value is not a number, return null
      if (isNaN(parsedValue)) {
        return null;
      }

      // Check if the original value ends with a percent symbol or percent renderer (percents can copy two different ways)
      if (params.value.trim().endsWith('%')) {
        parsedValue = parsedValue / 100;
      }

      return parsedValue;
    }

    // return the original value if no conditions are met
    return params.value;
  };

  rowClassRules = {
    [StyleEditSectionStyles.editableRow]: (params: RowClassParams<any>) => {
      return params.data?.dataKey === ADJUSTED_APS;
    },
  };

  //#endregion
  render() {
    const { isLoading, transposedData } = this.state;
    if (!this.props.expanded) {
      // in the mounted but in un-expanded state, renderer nothing to save resources
      // note: this needs to be a real element, in order for the inViewport HOC to detect it's existence
      return <div></div>;
    }
    if (isLoading) {
      return <Overlay type="loading" visible={true} fitParent={true} qaKey="StyleEditSectionOverlay" />;
    }
    if (this.props.inViewport === false && this.props.enterCount === 0) {
      // this is a guard for MultiSection, in order to keep a large number of sections from rendering all at once
      // is uses a HOC to check if the component is in the viewport, otherwise we just render a blank space for it
      return <div data-qa="SectionNotInViewport" style={{ height: '300px', width: '100%' }}></div>;
    }

    const { multiSectionData } = this.props;
    const { actions } = this.state;
    let addColorButton;

    if (!isNil(actions)) {
      if (actions.addColor) {
        addColorButton = <StyleEditAddColorButton onClick={this.addColor} />;
      }
    }

    const columnDefs = this.state.transposedDefs;
    const exportOptions = this.getExportOptions();
    //@ts-ignore
    const excelRendererArr: ExcelStyle[] = Object.keys(exportOptions.excelRendererObj).map((key) => {
      if (exportOptions.excelRendererObj) {
        return {
          ...exportOptions.excelRendererObj[key],
          numberFormat: { format: exportOptions.excelRendererObj[key].numberFormat },
        };
      }
    });
    return (
      <React.Fragment>
        {!isNil(multiSectionData) && <StyleEditGridTitle title={multiSectionData.text} />}
        <div className={classes('ag-theme-material', StyleEditSectionStyles.sectionGrid)}>
          <ConfirmationModal {...this.state.confirmationModalProps} />
          <AgGridReact
            // rowData={this.props.sectionData?.rowGroupDataIndex ? transposedData : transposedData?.slice(1)}
            // columnDefs={columnDefs}
            defaultColDef={DEFAULT_COLDEF}
            // Set back to true for INT-5254, was changed for 5210 but not needed
            stopEditingWhenCellsLoseFocus={true}
            singleClickEdit={true}
            components={this.allGridComponents}
            headerHeight={this.props.multiSectionData ? 0 : 100}
            suppressBrowserResizeObserver={true}
            getRowId={this.getRowId}
            getRowHeight={this.getRowHeight}
            isExternalFilterPresent={this.isExternalFilterPresent}
            doesExternalFilterPass={this.doesExternalFilterPass}
            getContextMenuItems={this.getContextMenuItems}
            onGridReady={this.onGridReady}
            rowClassRules={this.rowClassRules}
            domLayout={'autoHeight'}
            onCellEditingStopped={this.onCellEditingStopped}
            suppressHorizontalScroll={true}
            groupDisplayType={'groupRows'}
            groupDefaultExpanded={1}
            groupRowRenderer={GroupRowCellRenderer}
            groupRowRendererParams={this.groupRowRendererParams}
            excelStyles={excelRendererArr}
            processCellFromClipboard={this.handleProcessCellFromClipboard}
          />
          {addColorButton}
          {this.renderAddColorModal()}
        </div>
      </React.Fragment>
    );
  }
}
export const ViewPortSensitiveStyleEditSection = handleViewport(StyleEditSection, {
  threshold: 0,
});
